import React from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import PropTypes from 'prop-types';

import SearchBox from '@/components/common/SearchBox';
import HeaderMenu from '@/HeaderMenu';
import LogoRede from '@/images/logo_rede.svg';
import CircleRede from '@/svg-icons/circle-rede';

const PageHeader = ({ sidebarCollapsed }) => {
  const { pathname } = useLocation();

  const meStr = window.sessionStorage.getItem('me');
  const me = meStr ? JSON.parse(meStr) : null;

  const isClientsPage = pathname.includes('/clients');

  return (
    <div className="relative z-[110] flex h-[54px] w-full bg-[#d8d8d8]">
      <div 
        className={cn(
          "transition-all duration-300 flex items-center justify-center bg-[#143253] shrink-0",
          sidebarCollapsed ? "w-[70px]" : "w-[220px]"
        )}
      >
        <div className={sidebarCollapsed ? 'w-[70px] h-[60px] flex items-center justify-center' : 'w-[120px] flex items-center justify-center'}>
          {sidebarCollapsed ? <CircleRede className="w-[70px] h-[60px]" /> : <img src={LogoRede} alt="Logo Rede Vistorias" className="max-w-full" />}
        </div>
      </div>
      <div className="flex flex-1 items-center justify-between px-[16px] bg-[#d8d8d8] h-full">
        <div className="flex-[0_0_50%] pr-[16px] hidden md:block">
          <SearchBox redux isClientsPageHeader={isClientsPage} />
        </div>
        <div className="flex items-center h-full ml-auto">
          <HeaderMenu features={me?.features} userName={me?.name} />
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  sidebarCollapsed: PropTypes.bool.isRequired,
};

export default PageHeader;
